<template>
  <div class="page border-box VR"  v-wechat-title="$route.meta.title='导游带您游成都'">
    <!--
    <div class="tab-box box">
      <div class="flex tab-item" :class="tabState==1?'curr':''" @click="tabStateFun(1)"><span>分类1</span></div>
      <div class="flex tab-item" :class="tabState==2?'curr':''" @click="tabStateFun(2)"><span>分类2</span></div>
      <div class="flex tab-item" :class="tabState==3?'curr':''" @click="tabStateFun(3)"><span>分类3</span></div>
      <div class="flex tab-item" :class="tabState==4?'curr':''" @click="tabStateFun(4)"><span>分类4</span></div>
      <div class="flex tab-item" :class="tabState==5?'curr':''" @click="tabStateFun(5)"><span>分类5</span></div>
      <div class="flex tab-item" :class="tabState==6?'curr':''" @click="tabStateFun(6)"><span>分类6</span></div>
    </div>
    -->

    <div class="desc-box border-box">
      <div class="banner-box">
        <Swiper :banners="banners" :type="'videoc'"></Swiper>
      </div>
    </div>


    <!--新增全景视频模块-->
    <div class="video-vr border-box clearfix">
      <div class="video-vr-con border-box" v-for="(item,index) in root">
        <div class="video-vr-top" @click="toDesc(item)">
          <div class="video-vr-mask border-box">
            <img class="icon_360" src="../../assets/icon_play_btn03.png" alt="">
            {{item.listen | initNumber}}
            <span class="time fr">{{item['2'] | initTime}}</span>
          </div>
          <img class="video-vr-img" :src="item.img" alt="">
        </div>
        <div class="video-vr-bot border-box clearfix">
          <span class="video-vr-name hide2">{{item.name}}</span>
        </div>
        <div class="video-vr-bot2 border-box clearfix">
          <span>{{item.guidetag}}</span>
        </div>
        <div class="video-vr-bot1 border-box clearfix">
          <svg class="icon" width="16" height="16" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" fill="white" fill-opacity="0.01"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" stroke="#999999" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
            <path d="M24 23C26.7614 23 29 20.7614 29 18C29 15.2386 26.7614 13 24 13C21.2386 13 19 15.2386 19 18C19 20.7614 21.2386 23 24 23Z" fill="none" stroke="#999999" stroke-width="4" stroke-linejoin="bevel"/>
            <path d="M10.022 38.332C10.3657 33.1206 14.7016 29 20 29H28C33.2914 29 37.6229 33.1097 37.9767 38.3113" stroke="#999999" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
          </svg>
          <span>{{item.guide}}</span>
          <!--<span>{{item.guide}} <font>• {{item.guidetag}}</font></span>-->
        </div>
      </div>
    </div>
    <p class="load-tip" ref="loadtip">{{loadText}}</p>



  </div>

</template>

<script>
  import {videoCList, } from "@/service/getData";
  import {wxGetPosition,getCityInfo,wxShareme,wxOpenMapLocation} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import Swiper from '../../components/Swiper'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        siteid: this.$route.query.siteid || '',//站点id
        sregion: this.$route.query.sregion || '',//省站点id:430000
        userInfo: {}, //用户信息
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        tabState:1,//分类
        playing: 1, //1播放
        full: 1, //1全屏
        currVideo: '',
        page:1,
        rows: 20,
        root: [],
        loadText: "数据加载中",
        banners:[
          {
            id: 97,
            img: "https://filewc.geeker.com.cn/files/夜游锦江.png",
            name: '夜游锦江',
            isvideo: 0
          }, {
            id: 69,
            img: "https://filewc.geeker.com.cn/files/人民公园.png",
            name: '人民公园',
            isvideo: 0
          }, {
            id: 7,
            img: "https://filewc.geeker.com.cn/files/四川大学.png",
            name: '四川大学',
            isvideo: 0
          }, {
            id: 71,
            img:"https://filewc.geeker.com.cn/files/锦门.png",
            name: '锦门',
            isvideo: 0
          }, {
            id: 87,
            img:"https://filewc.geeker.com.cn/files/竹艺村.png",
            name: '竹艺村',
            isvideo: 0
          }
        ]
      }
    },
    computed: {

    },
    beforeRouteLeave(to, from, next) {
      if(this.currVideo&&this.currVideo.url){
        this.currVideo = '';
        next(false);
      }else {
        next();
      }
    },
    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.videoCListFun(this.page);

      window.addEventListener("scroll",this.handleFun);

    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
    },
    methods: {

      async videoCListFun(page){

        let res = await videoCList({
          TimeStamp: this.TimeStamp,
          page: page,
          rows: this.rows
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total
          var root = res.data.root

          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = '导游带您游成都';
          let desc = this.userInfo.name + '@你：我正在“金牌解说”，一起来听景区故事吧';
          let link = '/video-list-cd?appKey='+(this.appKey);
          wxShareme(title,desc,"https://filewc.geeker.com.cn/files/夜游锦江.png",link);

        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.videoCListFun(page);
          });
        })
      },

      openVideo: function (item){
        this.currVideo = item;
        var Video = document.getElementById("myVideo");
        if(Video && Video.paused){
          Video.play();
        }
        this.playing = 1;
        this.full = 1;
      },
      //关闭
      fullClick1: function(){
        this.currVideo = '';
        var Video = document.getElementById("myVideo");
        if(Video && !Video.paused){
          Video.pause();
        }
      },

      //全屏
      fullClick: function(){
        var Video = document.getElementById("myVideo");
        if(Video.paused){
          Video.play();
          this.playing = 1;
        }
        if(this.full==1){
          this.full = 0;
        }else {
          this.full = 1;
        }
      },
      //播放或暂停
      playVideo(){
        var Video = document.getElementById("myVideo");
        if(this.playing != 1){
          Video.play();
          this.playing = 1;
        }else {
          Video.pause();
          this.playing = 0;
        }

      },

      //打开地图
      openMap: function (lnglat,title){
        wxOpenMapLocation(lnglat[1], lnglat[0], title, '');
      },

      //切换分类
      tabStateFun:function(state){
        this.tabState = state;
      },

      //跳转视频详情
      toDesc:function(item){
        this.$router.push({
          path: `/video-list-cd-detail?${'id='+ item.id }`
        });
      }

    },
    watch:  {},
    components: {Swiper},
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";

  .page{ /*padding-top:.88rem;*/padding-top:.2rem;padding-bottom: .2rem;min-height:100vh;background: #f5f5f5; }
  /*顶部切换*/
  .tab-box{position: fixed;top:0;left: 0;z-index: 9;width: 100%;height:.72rem;font:.26rem/.72rem "Microsoft YaHei";color:#555;white-space:nowrap;background: #fff;border-bottom: 1px solid #e3e3e3;overflow-x: auto;}
  .tab-box .tab-item{text-align: center;}
  .tab-box .tab-item span{position: relative;display: inline-block;}
  .tab-box .tab-item.curr span{color: #fcba5a;}
  .tab-box .tab-item.curr span:after{content: '';position: absolute;left: 0;right: 0;bottom: 0;height: .04rem;background: #fcba5a;}
  /*banner图*/
  .desc-box{padding: 0 .2rem;}
  .banner-box{width: 100%;height: 3.8rem;background-color: #fff;}

  /*全景视频*/
  .video-vr{padding: 0 .2rem .4rem;}
  .video-vr-con{ float:left;width: 50%;margin-top: 8px;padding-left: 4px; border-radius: .08rem;box-shadow: 0 0 0.1rem #ddd;overflow: hidden;}
  .video-vr-con:nth-of-type(2n+1){padding-right: 4px;padding-left: 0;}
  .video-vr-top{display: block; position:relative;width: 100%; height: 30vw;border-radius: .08rem .08rem 0 0;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .08rem .08rem 0 0;object-fit: cover; overflow: hidden;}
  .video-vr-mask{position: absolute;z-index: 1;bottom:0;left: 0;width: 100%;height: .52rem;padding:0 .16rem;
    /*background: rgba(0,0,0,.3);*/
    background: -webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.85)),to(transparent));
    background: linear-gradient(0deg,rgba(0,0,0,.85),transparent);
    font: .2rem/.52rem "Microsoft YaHei";color: #fff;}
  .video-vr .icon_360{width: .28rem;height: .28rem;margin-right:.06rem;margin-top:.1rem;vertical-align: top;object-fit: contain;}
  .video-vr-bot{position:relative;width:100%;padding: .1rem .16rem 0; background: #fff;}
  .video-vr-name{height:.36rem;color: #212121;font:.26rem/.36rem "Microsoft YaHei";}
  /*.page.VR .buy-btn{ top: .1rem; background: none; }*/
  /*.page.VR .buy-btn svg{ width: .45rem;height: .45rem;}*/
  .video-vr-bot2{padding: 0 .16rem; background: #fff;height:.36rem;color: #999;font:.22rem/.36rem "Microsoft YaHei";}
  .video-vr-bot1{padding: 0 .16rem .1rem; background: #fff;}
  .video-vr-bot1 span{height:.42rem;color: #999;font:.22rem/.42rem "Microsoft YaHei";}
  .video-vr-bot1 .icon{ color: #999;width: .26rem;vertical-align: text-bottom; }

  .pvideo{display:none;position: fixed;right: 0;top: 0;z-index: 1;width: 100vw;height: 100vh;background-color: #eee;pointer-events: none;}
  .pvideo.curr{display:block;pointer-events: auto;}
  .pvideo-top{position: relative;width: 100%;height: 100%;display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center}
  .pvideo-top video{width: 100%;height: 100%;object-fit: cover;vertical-align: baseline;background-color: #000;}
  .pvideo-top .icon-video{position: absolute;left: 50%;top: 50%;z-index:9;width: .72rem;height: .72rem;transform: translate(-50%,-50%);background: none;pointer-events: none;}
  .pvideo-top  .icon-fulls{position: absolute;right: .23rem; top: .23rem; z-index: 1; width: .52rem; height: .52rem;background: none;}

  .pvideo-box.curr{position: fixed;left:0;top:0;right:0;bottom:0; width: 100%; height: 100%;z-index: 999;}
  .pvideo-box.curr .pvideo-top video{width: 100vh;-webkit-transform: rotate(90deg); transform: rotate(90deg); }
  .pvideo-box.curr .pvideo-top .icon-fulls{bottom: 0.23rem; top: auto; }
</style>
<style>
  .page.VR .psv-container{ position: absolute; padding: 1px; left:-1px; top:-1px; right:-1px; bottom:-1px; }
  .banner-box .swiper-box .swiper-pagination {left: initial;right: 5%;width: auto;}
  .banner-box .swiper-box .swiper-pagination-bullet { width: .1rem;height: .1rem;border-radius: .1rem; }
  .banner-box .swiper-pagination-bullet-active{width: .1rem;}
</style>



// WEBPACK FOOTER //
// src/page/video-vrlist/video-list-cd.vue